module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "id": "nav-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/logo.png",
      "alt": "Apollo Logo"
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "nav-bar-mobile",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobileMenu($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/h.svg"
    }
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "nav-bar"
    }
  }, [(!_vm.disabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/adminproposal",
      "title": "proposalA"
    }
  }, [_vm._v("---")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/supplierproductproposal",
      "title": "proposalS"
    }
  }, [_vm._v("---")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/user"
    }
  }, [_vm._v("User")])], 1) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/about",
      "title": "about"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/locations",
      "title": "locations"
    }
  }, [_vm._v("Locations")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "cta cta-link-perm",
    attrs: {
      "to": "/user"
    }
  }, [_vm._v(_vm._s(_vm.user.username))])], 1) : _vm._e(), _vm._v(" "), (_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#",
      "title": "logout"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "cta",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1) : _vm._e(), _vm._v(" "), (!_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "cta cta-link-perm",
    attrs: {
      "to": "/account-selection"
    }
  }, [_vm._v("Sign Up!")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('li', [_c('router-link', {
    staticClass: "cart-link",
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("Cart: " + _vm._s(_vm.cart))])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "how-to.php",
      "title": "suppliers"
    }
  }, [_vm._v("Suppliers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec55a06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 158
// module chunks = 0